import React from "react";
import {observer} from "mobx-react";
import {
    IOrganizationCreditPaymentMethodViewModel
} from "../../../../services/booking/models/payment/methods/organization-credit/organization-credit-payment-method.view-model.interface";
import styled from "styled-components";
import {CardBox} from "../../../../basic-components/card/card.box";
import {CheckboxComponent} from "../../../../basic-components/checkbox/checkbox.component";
import {PriceComponent} from "../../../../components/price/price.component";
import {Price} from "../../../../services/currency/price";
import {useServices} from "../../../../hooks/use-services.hook";


const ContainerBox = styled(CardBox)<{$disabled: boolean}>`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${props => props.theme.spacing.flexGap12};
    opacity: ${props => props.$disabled ? 0.4 : 1};
`

const TitleBox = styled.span`
    font-size: ${props => props.theme.fontSize.h4};
    font-weight: ${props => props.theme.fontWeight.semiBold};
`

const AmountsBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${props => props.theme.spacing.flexGap20};
    padding-left: ${props => props.theme.spacing.spacing48};
`

const AmountContainerBox = styled.div`
    display: flex;
    flex-direction: column;
`

const AmountLabelBox = styled.span`
    font-size: ${props => props.theme.fontSize.body2};
`

const PriceBox = styled(PriceComponent)`
    font-weight: ${props => props.theme.fontWeight.semiBold};
`

const AmountContainerComponent: React.FC<{amount: Price; label: string}> = (props) => {
    return (
        <AmountContainerBox>
            <AmountLabelBox>{props.label}</AmountLabelBox>
            <PriceBox price={props.amount}/>
        </AmountContainerBox>
    )
}


export const OrganizationCreditPaymentMethodComponent: React.FC<{organizationCredit: IOrganizationCreditPaymentMethodViewModel}> = observer((props) => {
    const services = useServices();
    if(props.organizationCredit.available.amount <= 0 && props.organizationCredit.used.amount <= 0) {
        return null;
    }



    const renderUsedAmount = () => {
        if(!props.organizationCredit.useAgencyCredit) {
            return null;
        }

        return (
            <AmountContainerComponent amount={props.organizationCredit.used} label={services.language.translate('Used')}/>
        );
    }

    const onChange = (isChecked: boolean) => {
        props.organizationCredit.useAgencyCredit = isChecked;
    }


    const isDisabled = props.organizationCredit.isDisabled;
    return (
        <ContainerBox $disabled={isDisabled}>
            <TitleBox>
                <CheckboxComponent checked={props.organizationCredit.useAgencyCredit}
                                   label={services.language.translate('Agency funds')}
                                   labelPlacement={"end"}
                                   disabled={isDisabled}
                                   onChange={onChange}/>
            </TitleBox>
            <AmountsBox>
                <AmountContainerComponent amount={props.organizationCredit.available}
                                          label={services.language.translate('Available')}/>
                {renderUsedAmount()}
            </AmountsBox>

        </ContainerBox>
    )
})